import React from "react";
import styled, { keyframes } from "styled-components/macro";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import MainContainer from "./elements/MainContainer";
import TranslateScript from "./elements/TranslateScript";

const Background = styled.div`
  display: ${({ show }) => (show ? `flex` : `none`)}; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 97; /* Sit on top */

  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */

  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  height: 50%;
  width: 30%;

  overflow: hidden;

  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 20% 50% 30%;
  grid-template-areas:
    "title"
    "content"
    "bottom";

  border-radius: 0.5em;
  background: white;
  margin: auto;
  position: relative;
`;

const Title = styled.div`
  grid-area: title;
  text-align: center;
  font-size: 2em;
  font-weight: 700;
  background: ${({ theme }) => theme.primary};
  color: white;
`;

const Content = styled.div`
  grid-area: content;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Description = styled.div`
  font-size: 1.2em;
  width: 80%;
  height: 80%;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
`;

const Bottom = styled.div`
  grid-area: bottom;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled(FontAwesomeIcon)`
  font-size: 2em;
  color: ${({ theme }) => theme.primary};
  animation: ${spin} 1.5s linear infinite;
`;

const Load = ({ load: { show, loadMessage } }) => {
  return (
    <Background show={show}>
      <MainContainer>
        <Container>
          <Title>
            <TranslateScript>Please wait</TranslateScript>
          </Title>

          <Content>
            <Description>{loadMessage}</Description>
          </Content>

          <Bottom>
            <Spinner icon={faSpinner} />
          </Bottom>
        </Container>
      </MainContainer>
    </Background>
  );
};

const mapStateToProps = ({ load }) => ({ load });

export default connect(mapStateToProps, null)(Load);
